import { createHashHistory } from 'history'

const history = createHashHistory({ basename: '/' })

export default history
